import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../common/hooks/useI18n'
import { UseTypeFontSize } from '../../common/hooks/useTypeFontSize'
import { Element } from '../../common/html/element'
import { FORMAT, formatDateTime } from '../../helpers/datetime'
import { getFontSize } from '../../helpers/fontSize'
import { ID_BLOCK_FS, ID_BLOCK_SCORE, convertAvailableFSData } from '../helper'
import classes from '../index.module.scss'

const WIDTH_FINANCIAL_STATEMENT_DEFAULT = 250
const WIDTH_FINANCIAL_STATEMENT_ITEM_DEFAULT = 150

const DataBlock = ({ detail }) => {
  const typeFontSize = UseTypeFontSize()
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <div className={classes.itemData}>
      <div className={classes.column1} />
      <div className={classes.column2}>
        <div>
          <div className="dFlex gap1">
            <div className="fw600">
              <Translate value="cartAndOrders.main.availableData" />:
            </div>
            <div>{convertAvailableFSData(detail)}</div>
          </div>
          {!!detail?.dataBlocks[0] && (
            <div className={classes.pdt8}>
              <div className="fw600 pb1">
                <Translate value="cartAndOrders.cart.selectDatBlocks" />:
              </div>
              <div className="pl3">
                {detail.dataBlocks?.map(
                  ({ name, id, reportingDate }, index) => {
                    return (
                      <div key={id} style={{ marginTop: index ? 4 : 0 }}>
                        {id !== ID_BLOCK_FS ? (
                          <>
                            {id === ID_BLOCK_SCORE ? (
                              <>
                                {name}&nbsp; (
                                <Translate value="score.main.LAST_UPDATE_DATE" />
                                &nbsp;
                                {formatDateTime(
                                  reportingDate,
                                  FORMAT.DATE,
                                  locale,
                                )}
                                )
                              </>
                            ) : (
                              name
                            )}
                          </>
                        ) : (
                          <div className="dFlex">
                            <div className={classes.titleFs}>
                              {name}: &nbsp;
                            </div>
                            <div>
                              <div className={classes.pdl10}>
                                <div>{detail.sourceOrganizationId}</div>
                                <div>
                                  {
                                    <Translate
                                      value={`cartAndOrders.main.${
                                        detail.consolidated
                                          ? 'CONSOLIDATED'
                                          : 'UNCONSOLIDATED'
                                      }`}
                                    />
                                  }
                                </div>
                              </div>
                              {!!detail?.yearsFS[0] && (
                                <div
                                  style={{
                                    width:
                                      getFontSize(
                                        WIDTH_FINANCIAL_STATEMENT_DEFAULT,
                                        typeFontSize,
                                      ) * 1.5,
                                  }}
                                  className={`${classes.mt4} ${classes.fsItemContainer}`}
                                >
                                  {detail.yearsFS
                                    .map(
                                      (year) =>
                                        `${year}: ${UseI18n(
                                          `cartAndOrders.main.${
                                            detail.auditStatuses[year]
                                              ? 'AUDITED'
                                              : 'UNAUDITED'
                                          }`,
                                        )}, ${UseI18n(
                                          `cartAndOrders.main.${
                                            detail.methods[year]
                                              ? 'DIRECT'
                                              : 'INDIRECT'
                                          }`,
                                        )}`,
                                    )
                                    .map((val, index) => {
                                      const isLeft =
                                        index === 1 ||
                                        index === 2 ||
                                        index === 4
                                      return (
                                        <Element
                                          key={index}
                                          style={{
                                            borderLeft: isLeft
                                              ? '1px solid #D5D5D5'
                                              : undefined,
                                            textAlign: 'left',
                                            padding: '0 10px',
                                            width: getFontSize(
                                              WIDTH_FINANCIAL_STATEMENT_ITEM_DEFAULT,
                                              typeFontSize,
                                            ),
                                          }}
                                          className={classes.fsItem}
                                        >
                                          {val}
                                        </Element>
                                      )
                                    })}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  },
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default DataBlock
